module.exports = __webpack_public_path__ + "img/eco-unfriendly.0a465ac0.png";